const sessionManagerKey = {
    isAdmin : 'isAdmin',
    userSeq : 'user_seq',
    userName : 'user_name',
    isResetPassword : 'is_reset_password',
}

export default sessionManagerKey
